<template>
    <div class="main_content">
        <location-line />
        <common-data-table hover class="" :totalPage="totalPage" :curPage="curPage">
            <template slot="header">
                <b-thead>
                    <b-tr>
                        <b-th> ID </b-th>
                        <b-th> 권한 </b-th>
                        <b-th> IP </b-th>
                        <b-th> 등록일 </b-th>
                        <b-th> 말소일 </b-th>
                    </b-tr>
                </b-thead>
            </template>
            <template slot="body">
                <b-tbody>
                    <b-tr v-for="(item, index) in items" :key="index">
                        <b-td> {{ item.id }} </b-td>
                        <b-td> {{ item.auth | lbsAuth }} </b-td>
                        <b-td> {{ item.ip }} </b-td>
                        <b-td> {{ item.indate }} </b-td>
                        <b-td> {{ item.outdate }} </b-td>
                    </b-tr>
                </b-tbody>
            </template>
        </common-data-table>
    </div>
</template>

<script>
import commonDataTable from '@/components/common/table/DataTable'
import LocationLine from '@/components/LocationLine'
import '@/filter/lbs'
import ax from '@/api/lbs'

export default {
    components: {
        commonDataTable,
        LocationLine
    },

    data() {
        return {
            curPage: parseInt(this.$route.query.page) || 1,
            totalPage: 1,
            items: []
        }
    },

    created() {
        this.init()
    },

    methods: {
        init() {
            ax.memberList(this.curPage, (data) => {
                if (data) {
                    this.items = data.items
                    this.totalPage = data.totalPage
                } else {
                    this.items = []
                    this.totalPage = 1
                }
            })
        }
    },

    watch: {
        '$route.query': function () {
            this.curPage = parseInt(this.$route.query.page) || 1
            this.init()
        }
    }
}
</script>